import React from 'react';
import {StyledPopUp} from "../../../../shared";
import {FilterPopupProps} from "../../models";
import {Button, Drawer, Flex, Form, Input, Select, Slider, Space} from "antd";
import {useForm} from "antd/es/form/Form";

const FilterPopup = ({open, onCansel, onFilterApply}: FilterPopupProps) => {
    const [form] = useForm();

    const onFinish = (value:any) => {
        onFilterApply(value)
        onCansel()
    }
    const onReset = (value:any) => {
        onFilterApply(null)
        onCansel()
    }

    return (
        <Drawer
            height={"100%"}
            placement="bottom"
            open={open}
            onClose={onCansel}
            title={"فیلتر"}
            closable={true}

        >

            <Form form={form} onFinish={onFinish} onReset={onReset}>
                <Flex vertical>
                    <Form.Item label={'مرتب سازی'} name={'sortBy'}>
                        <Select options={[{label: 'da', value: 'da'}]}
                        />
                    </Form.Item>
                    <Form.Item label={'وضعیت'} name={'statusId'}>
                        <Select options={[{label: 'da', value: 'da'}]}
                        />
                    </Form.Item>
                    <Form.Item label={'قیمت از'} name={'fromPrice'}>
                        <Input/>
                    </Form.Item>
                    <Form.Item label={' قیمت تا'} name={'toPrice'}>
                        <Input/>
                    </Form.Item>
                    <Flex gap={"middle"}>
                        <Button block size={"middle"} htmlType={"reset"} onClick={onCansel}>حذف فیلتر</Button>
                        <Button block size={"middle"} type="primary" htmlType={"submit"}>

                            اعمال
                        </Button>
                    </Flex>
                </Flex>
            </Form>
        </Drawer>
    );
};

export default FilterPopup;